import { render, staticRenderFns } from "./DeliveryOrderSideBar.vue?vue&type=template&id=4a60cd4c&scoped=true&"
import script from "./DeliveryOrderSideBar.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrderSideBar.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOrderSideBar.vue?vue&type=style&index=0&id=4a60cd4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a60cd4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a60cd4c')) {
      api.createRecord('4a60cd4c', component.options)
    } else {
      api.reload('4a60cd4c', component.options)
    }
    module.hot.accept("./DeliveryOrderSideBar.vue?vue&type=template&id=4a60cd4c&scoped=true&", function () {
      api.rerender('4a60cd4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/delivery-dashboard/components/DeliveryOrderSideBar.vue"
export default component.exports